<template>
	<!-- 푸터 start -->
	<div class="bot_footer">
		<div class="accessibility_blank">
			<!-- 자주 묻는 질문 start -->
			<faq
				:user-info="userInfo"
				:show="faqShow"
				:chatActive="chatActive"
				:writingDisable="writingDisable"
				@msgClick="clickMessage"
			/>
			<!--// 자주 묻는 질문 end -->

			<!-- 하단 메뉴 start -->
			<ul class="contact_area">
				<li class="btn_faq" style="cursor: pointer;">
					<a class="btn_faq" :class="{ on: faqShow }"
						><i class="fas fa-question" />자주 묻는 질문</a
					>
				</li>
				<li style="cursor: pointer;" @click="onClickSaveInquiry">
					<a><i class="fas fa-envelope-open-text" />의견 보내기</a>
				</li>
			</ul>
			<!--// 하단 메뉴 end -->

			<!-- 입력 영역 start -->
			<div class="send_area">
				<div class="send_form">
					<fieldset>
						<legend>질문 입력</legend>
						<div class="input_wrap">
							<input
								id="send_input"
								ref="content"
								v-model="content"
								type="text"
								class=""
								:placeholder="getPlaceholder"
								:disabled="!chatActive"
								@keyup.up.down="onKeyEvent($event)"
								@keypress.enter="onKeyEvent($event)"
								@input="content = $event.target.value"
							/>
							<button
								type="button"
								class="btn_send fas fa-arrow-up"
								:class="{ disabled: !chatActive | writingDisable | !content }"
								@click="writeContent"
							>
								<span class="bg_clip">보내기</span>
							</button>
						</div>
					</fieldset>
				</div>
			</div>
			<!--// 입력 영역 end -->

			<!-- 자동완성 start -->
			<auto-complete
				:user-info="userInfo"
				:content="content"
				:autoCompleteShow="autoCompleteShow"
				:writingDisable="writingDisable"
				@msgClick="clickMessage"
			/>
			<!--// 자동완성 end -->
			<a v-if="faqShow" href="#" class="modal_blanklink">포커스이동</a>
		</div>
	</div>
	<!--// 푸터 end -->
</template>

<script>
// eslint-disable-next-line no-undef
require('es6-promise').polyfill();
import EventBus from '../eventBus/eventBus';
import Faq from './Faq';
import SaveInquiry from './SaveInquiry';
import AutoComplete from './AutoComplete';

export default {
	name: 'WritingArea',
	components: {
		faq: Faq,
		'auto-complete': AutoComplete,
	},
	props: {
		userInfo: {
			type: Object,
			default: null,
			required: false,
		},
		autoCompleteShow: {
			type: Boolean,
			default: false,
			required: false,
		},
		faqShow: {
			type: Boolean,
			default: false,
			required: false,
		},
		// 특정 서비스 중 입력창 disable
		chatActive: {
			type: Boolean,
			default: false,
			required: false,
		},
		// 질의 보낸 후 답변 오기전까지 전송 disable
		writingDisable: {
			type: Boolean,
			default: false,
			required: false,
		},
		messageList: {
			type: Array,
			default: null,
			required: false,
		},
	},
	data() {
		return {
			content: '',
		};
	},
	mounted() {
		this.$refs.content.focus();
	},
	computed: {
		getPlaceholder() {
			if (!this.chatActive) {
				return '사용자 정보를 등록할 때는 질문을 입력하실 수 없습니다.';
			} else {
				return '여기에 질문을 입력해 주세요.';
			}
		},
	},
	methods: {
		writeContent() {
			let vm = this;
			if (
				(vm.content == '') |
				(vm.content == '\n') |
				(vm.content.replace(/ /g, '') == '')
			) {
				vm.clearTextArea();
				return;
			} else {
				vm.$emit('writeContent', vm.content, vm.content);
				vm.clearTextArea();
			}
		},
		clickMessage(content) {
			this.content = content;
			this.writeContent();
		},
		clearTextArea() {
			// 입력창 초기화
			this.content = '';
		},
		onKeyEvent(event) {
			EventBus.$emit('autoCompList', event);
		},
		onClickSaveInquiry() {
			
			this.$modal.show(
				SaveInquiry,
				{
					userInfo: this.userInfo,
					messageList: this.messageList,
				},
				{
					height: 'auto',
				},
			);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/WritingArea.vue